"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _Link = _interopRequireDefault(require("../Link"));

var _scrollUpButton = _interopRequireDefault(require("./scrollUpButton.proptypes"));

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ScrollUpButtonStyle = (0, _styledComponents.default)(_Link.default).withConfig({
  displayName: "ScrollUpButton__ScrollUpButtonStyle",
  componentId: "sc-k72wv8-0"
})(["bottom:", ";right:", ";padding 14px 14px;position:fixed;border:1px solid ", ";border-radius:50%;width:", ";height:", ";font-family:", ";font-size:", ";color:", ";background-color:", ";text-align:center;box-sizing:border-box;text-decoration:none;box-shadow:", ";display:inline-block;z-index:", ";&:hover{color:", ";background-color:", ";}display:flex;align-items:center;justify-content:center;"], function (props) {
  return props.bottom ? props.bottom : props.theme.space.large;
}, function (props) {
  return props.right ? props.right : props.theme.space.semi;
}, function (props) {
  return props.border ? props.theme.colors[props.border] : props.theme.colors.greyLighter;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.space.large;
}, function (props) {
  return props.theme.fontFamily.default;
}, function (props) {
  return props.theme.fontSize[props.size];
}, function (props) {
  return props.color ? props.theme.colors[props.color] : props.theme.colors.primary;
}, function (props) {
  return props.backgroundColor ? props.theme.colors[props.backgroundColor] : props.theme.colors.default;
}, function (props) {
  return props.boxShadow ? '0px 1px 1px rgba(0, 0, 0, 0.2)' : 'none';
}, function (props) {
  return props.zIndex || '99';
}, function (props) {
  return props.hoverColor ? props.theme.colors[props.hoverColor] : props.theme.colors.default;
}, function (props) {
  return props.hoverBackgroundColor ? props.theme.colors[props.hoverBackgroundColor] : props.theme.colors.greyLight;
});

var ScrollUpButton = function ScrollUpButton(_ref) {
  var onClickTrigger = _ref.onClickTrigger,
      theme = _ref.theme,
      stopPosition = _ref.stopPosition,
      style = _ref.style,
      isSmooth = _ref.isSmooth,
      icon = _ref.icon,
      fontsize = _ref.fontsize;
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);

  var handleClick = function handleClick() {
    var posY = window.pageYOffset;

    if (posY > stopPosition) {
      window.scroll({
        top: stopPosition,
        left: 0,
        behavior: isSmooth ? 'smooth' : 'auto'
      });
    }

    if (onClickTrigger && typeof onClickTrigger === 'function') {
      onClickTrigger();
    }
  };

  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(ScrollUpButtonStyle, (0, _extends2.default)({
      id: "scrollUpButton",
      target: "callback",
      callback: handleClick
    }, style), /*#__PURE__*/_react.default.createElement(_Icon.default, {
      icon: icon,
      fontsize: fontsize,
      theme: theme
    }));
  };

  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};

var _default = ScrollUpButton;
exports.default = _default;
ScrollUpButton.propTypes = _scrollUpButton.default.PropTypes;
ScrollUpButton.defaultProps = _scrollUpButton.default.DefaultProps;